// https://developer.mozilla.org/en-US/docs/Web/API/Element.matches
if (!("matches" in document.documentElement) && Object.defineProperty && typeof Element !== 'undefined') {
	Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector;
}